module.exports = __webpack_public_path__ + "static/media/industry-solutions.5dd61425.svg";